/**
 * URL de base de l’API (sans suffixe /api — les appels font `${API_URL}/api/...`).
 *
 * Sur https://annuaire-interne.prysme.eu le bundle doit appeler `/api/...` (même origine)
 * pour que nginx du conteneur front proxifie vers l’API. Si Coolify laisse
 * REACT_APP_BACKEND_URL=https://api-annuaire-interne… au build, sans ce correctif
 * le navigateur reste en cross-origin → prévol CORS bloqué.
 *
 * Désactiver le forçage same-origin : REACT_APP_CROSS_ORIGIN_API=1 au build.
 */
function normalizeBase() {
  const crossOriginForced =
    process.env.REACT_APP_CROSS_ORIGIN_API === '1' ||
    process.env.REACT_APP_CROSS_ORIGIN_API === 'true';

  if (!crossOriginForced && typeof window !== 'undefined' && window.location?.hostname) {
    const h = window.location.hostname.toLowerCase();
    if (
      h === 'annuaire-interne.prysme.eu' ||
      h === 'www.annuaire-interne.prysme.eu'
    ) {
      return '';
    }
  }

  const v = process.env.REACT_APP_BACKEND_URL;
  if (v == null || String(v).trim() === '') {
    return '';
  }
  return String(v).replace(/\/$/, '');
}

export const API_URL = normalizeBase();
